import React from 'react';

import Link from 'next/link';

import gmpImage from 'assets/images/pages/homepage/gmp.png';
import starsImage from 'assets/images/pages/homepage/stars.png';
import batchImage from 'assets/images/pages/homepage/batch.png';
import TickIcon from 'assets/icons/tick-circle.svg';
import TuvImage from 'assets/images/pages/homepage/tuvcertificate.png';
import Pharmacovigilance from 'assets/images/pages/homepage/pharmacovigilance.png';

import classes from './CorePharmaTopics.module.scss';

const CorePharmaTopics = () => {
    return (
        <div className='container'>
            <div className={classes['topics-wrapper']}>
                <h2>Explore Our Core Pharma Topics</h2>
                <p>
                    Dive into Pharmuni’s major categories—all designed to equip you with the essential
                    skills demanded by top pharmaceutical employers.
                </p>
                <div className='row'>
                    <div className='col-lg-4 col-12'>
                        <Link href='https://pharmuni.com/gmp/'>
                            <div className={`${classes['topic-green']} ${classes['gmp']}`}>
                                <h3 className='mb-4'>Good Manufacturing Practices (GMP)</h3>
                                <div className={classes['gmp-item']}>
                                    GMP Annex 1
                                </div>
                                <div className={classes['gmp-item']}>
                                    cGMP
                                </div>
                                <div className={classes['gmp-item']}>
                                    GxP
                                </div>
                                <div className={classes['gmp-item']}>
                                    GDP
                                </div>
                                <img src={gmpImage.src} alt='gmp' />
                            </div>
                        </Link>
                    </div>
                    <div className='col-lg-4 col-12 '>
                        <Link href='/explore?featured_contents=true&search_keyword=Pharmacovigilance'>
                            <div className={`${classes['topic-gray']} ${classes['pharmacovigilance']}`}>
                                <h3 className='mb-3'>Pharmacovigilance</h3>
                                <p>
                                    Drug Safety<br />
                                    Adverse Event Reporting<br />
                                    Risk Assessment
                                </p>
                                <img src={Pharmacovigilance.src} alt='stars' />
                            </div>
                        </Link>
                        <Link href='/explore?featured_contents=true&search_keyword=Regulatory'>
                            <div className={`${classes['topic-gray']} ${classes['regulatory']}`}>
                                <img src={starsImage.src} alt='stars' />
                                <h3 className='mb-3'>Regulatory</h3>
                                <p>
                                    EU Guidelines<br />
                                    FDA Guideline<br />
                                    Medical Device Regulations (MDR)<br />
                                    Regulatory Affairs
                                </p>
                            </div>
                        </Link>
                    </div>
                    <div className='col-lg-4 col-12'>
                        <Link href='/explore?featured_contents=true&search_keyword=validation'>
                            <div className={`${classes['topic-yellow']} ${classes['validation']}`}>
                                <h3>Validation</h3>
                                <p>
                                    Computer System <br /> Validation (CSV)<br />
                                </p>
                                <p>
                                    GAMP5
                                </p>
                            </div>
                        </Link>
                        <Link href='/explore?featured_contents=true&search_keyword=Quality+Management'>
                            <div className={`${classes['topic-gray']} ${classes['quality-wrapper']}`}>
                                <h3>Quality Management</h3>
                                <div className={classes['quality']}>
                                    <div className={classes['qm-item']}>
                                        Deviation Management
                                    </div>
                                    <div className={classes['qm-item']}>
                                        Quality Management System
                                    </div>
                                    <div className={classes['qm-item']}>
                                        Quality Control
                                    </div>
                                    <div className={classes['qm-item']}>
                                        Quality Assurance
                                    </div>
                                    <div className={classes['qm-item']}>
                                        Corrective and Preventive Action
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-lg-6 col-12'>
                        <Link href='/explore?featured_contents=true&search_keyword=Career+Development'>
                            <div className={`${classes['topic-yellow']} ${classes['career']}`}>
                                <h3>Career Development</h3>
                                <div className='d-flex justify-content-between flex-lg-nowrap flex-wrap gap-2 mb-2'>
                                    <div className={classes['career-item']}>
                                        <TickIcon /> Leadership
                                    </div>
                                    <div className={classes['career-item']}>
                                        <TickIcon />Communication
                                    </div>
                                </div>
                                <div className='d-flex flex-xl-nowrap flex-wrap  gap-2 mt-3'>
                                    <div className={`${classes['career-item']} ${classes['third-career']}`}>
                                        <TickIcon />Time Management
                                    </div>
                                    <div className={classes['career-item']}>
                                        <TickIcon />Project Management
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                    <div className='col-lg-6 col-12'>
                        <Link href='/explore?featured_contents=true&search_keyword=Batch+management'>
                            <div className={`${classes['topic-gray']} ${classes['batch']}`}>
                                <h3>Batch<br /> Management</h3>
                                <p>
                                    Batch Procedure <br />
                                    Batch Release
                                </p>
                                <img src={batchImage.src} alt='batch management' />
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
            <div className={classes['certificate-wrapper']}>
                <div className={`container `}>
                    <div className={`row ${classes['certificate']}`}>
                        <div className='col-lg-8 col-12 d-flex flex-column justify-content-center '>
                            <h3>ISO 9001 Quality You Can Trust</h3>
                            <p>
                                All Pharmuni courses are developed within the TÜV SÜD ISO 9001:2015-certified Quality Management
                                System of Zamann Pharma Support GmbH. This certification
                                covers personnel qualification in pharmacy, medical technology, and quality assurance.
                            </p>
                        </div>
                        <div className='col-lg-4 col-12 d-flex align-items-start justify-content-center'>
                            <div className={classes['image-wrapper']}>
                                <img src={TuvImage.src} alt='pharmuni certificate' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CorePharmaTopics;